import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SnackbarNotificationData {
  title?: string;
  message: string;
  icon?: string;
}

@Component({
  selector: 'app-snackbar-notification',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    <div class="snackbar-content">
      <mat-icon class="snackbar-leading-icon">{{ data.icon || 'error' }}</mat-icon>
      <div class="snackbar-text-block">
        <div class="snackbar-title" *ngIf="data.title">{{ data.title }}</div>
        <div class="snackbar-message">{{ data.message }}</div>
      </div>
      <button mat-icon-button type="button" class="snackbar-close" (click)="dismiss()" aria-label="Close notification">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  `,
  styles: [
    `
      .snackbar-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        padding: 2px 0;
      }

      .snackbar-leading-icon {
        color: #fff;
        font-size: 28px;
        width: 28px;
        height: 28px;
        flex-shrink: 0;
      }

      .snackbar-text-block {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
      }

      .snackbar-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: 0.3px;
      }

      .snackbar-message {
        font-size: 13px;
        font-weight: 400;
        line-height: 1.3;
        opacity: 0.92;
      }

      .snackbar-close {
        color: #fff;
        margin-left: auto;
        flex-shrink: 0;
        opacity: 0.85;
      }

      .snackbar-close:hover {
        opacity: 1;
      }
    `
  ]
})
export class SnackbarNotificationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public readonly data: SnackbarNotificationData,
    private readonly snackBarRef: MatSnackBarRef<SnackbarNotificationComponent>
  ) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
